import { createFileRoute } from "@tanstack/react-router";
import { PortalAppsCatalog } from "@/components/portal/apps/PortalAppsCatalog";

export const Route = createFileRoute("/portal/apps/")({
  component: PortalAppsPage,
});

function PortalAppsPage() {
  return <PortalAppsCatalog />;
}
